/**
 * Main JS file
 * Used for imports and simple global scripts
 */

(function(){

    window.onload = () => {
        console.log('window loaded'); 

        const toTop = document.querySelector('.back-to-top-btn'); 

        if( toTop && toTop != 'undefined' ){
            toTop.addEventListener('click', () => {
                window.scrollTo({
                    top: 300,
                    behavior: 'smooth'
                });
            }); 
        }
    }

}() ); 